import React from 'react'

import './privacypolicy.css';

const privacypolicy = () => {
  return (
    <>
      <div className="privacy-policy">
        <div className="container privacy-heading">
          <h1>Privacy Policy</h1>
        </div>
        <div className="container privacy-text">
          <p>Thank you for using our rewards app! Protecting your privacy and personal information is important to us. This privacy policy explains how we collect, use, and protect your personal information.</p>
          <ol type='1'>
            <li>Collection of Information: We collect personal information that you provide when you register for our app or use our services, such as your name, email address, phone number, and location data. We also collect information about your use of our app and services, such as the rewards you earn and the transactions you make.</li>
            <li>Use of Information: We use the personal information we collect to provide you with our services and to improve and customize your experience. We may also use your information to send you promotional offers or other marketing messages, but you can opt-out of receiving these messages at any time.</li>
            <li>Sharing of Information: We may share your personal information with third-party service providers who help us operate our app and provide our services, such as payment processors and marketing agencies. We may also share your information with our business partners for marketing purposes. However, we will not sell or rent your personal information to third parties without your consent.</li>
            <li>Security of Information: We take reasonable measures to protect your personal information from unauthorized access, disclosure, or misuse. However, no security measures are perfect, and we cannot guarantee the security of your information.</li>
            <li>Children's Privacy: Our app is not intended for use by children under the age of 13. We do not knowingly collect personal information from children under 13, and if we become aware that we have collected such information, we will delete it.</li>
            <li>Changes to this Privacy Policy: We may update this privacy policy from time to time. If we make significant changes, we will notify you by email or through our app. Your continued use of our app after we make changes to this policy constitutes your acceptance of the changes.</li>
          </ol>
          <p>If you have any questions or concerns about our privacy policy, please contact us at </p>
          <p>RewardPro</p>
          <p>D-63</p>
          <p>Sector 2 Noida</p>
          <p>Phone no. +91-9876543210</p>
          <p>Email - Contact@rewardpro.com</p>
        </div>
      </div>
    </>
  )
}

export default privacypolicy
